import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledRowImage = styled.div`
  padding: 5rem 0;
  background-color: ${(props: StyledRowImageProps) => props.backgroundColor};

  @media (max-width: ${theme.breakpoints[0]}) {
    padding: 5rem 0;
    text-align: center;

    p {
      text-align: initial;
    }

    iframe {
        width: 100% !important;
      }
  }

  & > div {
    display: flex;
    flex-direction: ${(props: StyledRowImageProps) =>
      props.imagePlacement ? `row-reverse` : `row`};

    @media (max-width: ${theme.breakpoints[1]}) {
      flex-direction: column-reverse;
    }
  }

  section {
    flex: 1;
    min-height: 150px;
    padding: 2.5rem 0;
    ${(props: StyledRowImageProps) =>
      props.imagePlacement
        ? `&:last-of-type {
      margin-right: 5rem;
    }`
        : `&:first-of-type {
      margin-right: 5rem;
    }`}

    @media (max-width: ${theme.breakpoints[1]}) {
      min-width: 80%;

      img {
        margin: 0 auto;
      }

      &:first-of-type, &:last-of-type {
        margin-right: 0;
      }

      .gatsby-image-wrapper {
        margin: 0 auto;
      }
    }

    div {
      padding: 1.3rem 0 2rem;
      margin: 0;
    }

    .children {
      padding: 3rem 0 0;
      margin: 0;
    }
  }
`

type StyledRowImageProps = {
  imagePlacement: boolean
  backgroundColor: string
}

export default StyledRowImage
